import {
    CHANGE_BIKE_MODEL_REQUEST_SUCCESS,
    GET_BIKE_MODELS_REQUEST_SUCCESS,
    GET_BIKE_MODELS_REQUEST,
    GET_BIKE_MODELS_REQUEST_FAILURE,
    COUNT_BIKE_MODELS_REQUEST_FAILURE,
    COUNT_BIKE_MODELS_REQUEST_SUCCESS,
    SEARCH_BIKE_MODEL_REQUEST,
    SEARCH_BIKE_MODEL_REQUEST_SUCCESS,
    SEARCH_BIKE_MODEL_REQUEST_FAILURE,
    CHANGE_BIKE_MODEL_LIST_REQUEST,
    CHANGE_BIKE_MODEL_LIST_REQUEST_SUCCESS,
    SEARCH_BIKE_REQUEST,
    SEARCH_BIKE_REQUEST_SUCCESS,
    SEARCH_BIKE_REQUEST_FAILURE,
    FILTER_SEARCH_REQUEST, FILTER_SEARCH_REQUEST_FAILURE, FILTER_SEARCH_REQUEST_SUCCESS,
    SEARCH_HC_REQUEST, SEARCH_HC_SUCCESS, SEARCH_HC_FAILURE,
} from '../constants/bike_model.constants';
import { SEARCH_BY_BRAND_REQUEST, SEARCH_BY_BRAND_REQUEST_SUCCESS, SEARCH_BY_BRAND_REQUEST_FAILURE } from '../constants/search_by_brand.constants';
import { SEARCH_BY_REG_REQUEST_SUCCESS } from '../constants/search_by_reg.constants';
import { GET_BIKE_MODEL_REQUEST_SUCCESS } from '../../../Bike_model_update/redux/constants/get_bike_model.constants';
import { CREATE_BIKE_MODEL_REQUEST_SUCCESS } from '../../../Bike_model_create/redux/constants/create_bike_model.constants';
import {
    SEARCH_BIKES_REQUEST, SEARCH_BIKES_SUCCESS, SEARCH_BIKES_FAILURE,
    SEARCH_BIKE_BRAND_REQUEST, SEARCH_BIKE_BRAND_SUCCESS, SEARCH_BIKE_BRAND_FAILURE,
    SEARCH_BIKE_MODELS_REQUEST, SEARCH_BIKE_MODELS_SUCCESS, SEARCH_BIKE_MODELS_FAILURE,
    SEARCH_BIKES_COUNT_REQUEST, SEARCH_BIKES_COUNT_SUCCESS, SEARCH_BIKES_COUNT_FAILURE,
} from '../constants/search_bikes.constants';
import { setVal } from '../../../../../shared/helpers';

const initialState = {
    loading: false,
    searchedData: null,
    isShow: false,
    models: [],
    variants: [],
    variant_id: null,
    brand_id: undefined,
    model_id: undefined,
    brands_data: null,
    models_data: null,
    // filters: {
    //
    // },
    where_condition: {
        model_OR_brand: undefined,
        ref_bike_brand: {
            _id: undefined,
        },
        ref_bike_model: {
            _id: undefined,
            $and: [
                // {$gte: ["$cc", value]},
                // {$lte: ["$cc", value]},
                { cc: undefined },
                { cc: undefined },
                { mileage_limit: undefined },
                { min_age: undefined },
                { is_hot: undefined },
                { is_no_buy: undefined },
                { wwym_priority: undefined },
                { leadomatic_priority: undefined },
                { check_luggage: undefined },
                { always_manual_price: undefined },
                { check_race_replica: undefined },
                { we_dont_want: undefined },
            ],
        },
        ref_bike_variant: { $and: [] },

        // variant: {
        //     $and: [
        //         {$eq: ["$is_hot", true]},
        //         {$eq: ["$is_no_buy", true]},
        //         {
        //             $or: [
        //                 {$exists: ["$duplicate_min", true]},
        //                 {$exists: ["$duplicate_max", true]},
        //             ],
        //         },
        //     ],
        // },
    },

    filters: {
        model_OR_brand: {
            display_name: 'Search for a Make or Model',
            db_key: 'model_OR_brand',
            value: undefined,
        },
        ref_bike_brand: {
            display_name: 'Make',
            db_key: 'ref_bike_brand',
            value: undefined,
        },
        ref_bike_model: {
            display_name: 'Model',
            db_key: 'ref_bike_model',
            value: undefined,
        },
        cc: {
            display_name: 'Engine capacity',
            db_key: 'cc',
            value: undefined,
        },
        bike_type: {
            display_name: 'Bike type',
            db_key: 'bike_type',
            value: undefined,
        },
        // ref_bike_variant: {
        //     display_name: "Bike type",
        //     db_key: "ref_bike_variant",
        //     value: undefined,
        // },
        mileage_limit: {
            display_name: 'Mileage limit',
            db_key: 'mileage_limit',
            value: undefined,
        },
        min_age: {
            display_name: 'Min age',
            db_key: 'min_age',
            value: undefined,
        },
        wwym_priority: {
            display_name: 'WWYM priority',
            db_key: 'wwym_priority',
            value: undefined,
        },
        leadomatic_priority: {
            display_name: 'Leadomatic priority',
            db_key: 'leadomatic_priority',
            value: undefined,
        },
        check_luggage: {
            display_name: 'Only with Luggage',
            db_key: 'check_luggage',
            value: undefined,
        },
        always_manual_price: {
            display_name: 'Only Manual Price Check',
            db_key: 'always_manual_price',
            value: undefined,
        },
        check_race_replica: {
            display_name: 'Only Race Replica',
            db_key: 'check_race_replica',
            value: undefined,
        },
        we_dont_want: {
            display_name: "Only We Don't Want",
            db_key: 'we_dont_want',
            value: undefined,
        },
        is_hot: {
            display_name: 'Only in Hot List',
            db_key: 'is_hot',
            value: undefined,
        },
        is_no_buy: {
            display_name: 'Only in Cold List',
            db_key: 'is_no_buy',
            value: undefined,
        },
        is_duplicate: {
            display_name: 'Only Duplicates',
            db_key: 'is_duplicate',
            value: undefined,
        },
    },
    filteredModels: [],
    filteredBrands: null,
    amount: 0,
    condition: null,
    where: {
        wwym_priority: undefined,
        we_dont_want: undefined,
        ref_bike_brand: undefined,
        alternative_name: undefined,
        name: undefined,
    },
    pagination: {
        page: 0,
        pageSize: 10,
    },
    advancedSearch: false,
    error: null,
};

export const Bike_management = (state = initialState, action) => {
    const {
        item, prefix, payload, condition, key, variant_id, variant, error,
    } = action;
    switch (action.type) {
    case 'SET_BIKE_MANAGEMENT_FILTER':
        // if ((action.params.db_key === "mileage_limit" || action.params.db_key === "min_age") && (action.params.value === 0 || action.params.value === "0")) {
        //     setVal(state.filters, `${action.params.db_key}.value`, undefined);
        // }
        setVal(state.filters, `${action.params.db_key}.value`, action.params.value);


        const $ref_bike_model_and = [];
        const $ref_bike_variant_and = [];
        for (const db_key in state.filters) {
            if (state.filters.hasOwnProperty(db_key)) {
                const filter = state.filters[db_key];

                if (db_key === 'ref_bike_brand') {
                    state.where_condition.ref_bike_brand._id = filter.value;
                } else if (db_key === 'ref_bike_model') {
                    state.where_condition.ref_bike_model._id = filter.value;
                } else if (db_key === 'cc' && filter.value !== undefined) {
                    $ref_bike_model_and.push({ $gte: ['$cc', filter.value - 20] });
                    $ref_bike_model_and.push({ $lte: ['$cc', Number(filter.value + 20)] });
                } else if (db_key === 'bike_type' && filter.value !== undefined) {
                    $ref_bike_model_and.push({ $eq: ['$bike_type', filter.value] });
                } else if (db_key === 'mileage_limit' && filter.value !== undefined) {
                    $ref_bike_model_and.push({ $eq: ['$mileage_limit', Number(filter.value)] });
                } else if (db_key === 'min_age' && filter.value !== undefined) {
                    $ref_bike_model_and.push({ $eq: ['$min_age', Number(filter.value)] });
                } else if (db_key === 'wwym_priority' && filter.value !== undefined) {
                    $ref_bike_model_and.push({ $eq: ['$wwym_priority', Number(filter.value)] });
                } else if (db_key === 'leadomatic_priority' && filter.value !== undefined) {
                    $ref_bike_model_and.push({ $eq: ['$leadomatic_priority', Number(filter.value)] });
                } else if (db_key === 'check_luggage' && filter.value === true) {
                    $ref_bike_model_and.push({ $eq: ['$check_luggage', filter.value] });
                } else if (db_key === 'always_manual_price' && filter.value === true) {
                    $ref_bike_model_and.push({ $eq: ['$always_manual_price', filter.value] });
                } else if (db_key === 'check_race_replica' && filter.value === true) {
                    $ref_bike_model_and.push({ $eq: ['$check_race_replica', filter.value] });
                } else if (db_key === 'check_has_abs' && filter.value === true) {
                    $ref_bike_model_and.push({ $eq: ['check_has_abs', filter.value] });
                } else if (db_key === 'we_dont_want' && filter.value === true) {
                    $ref_bike_model_and.push({ $eq: ['$we_dont_want', filter.value] });
                } else if (db_key === 'is_hot' && filter.value === true) {
                    $ref_bike_variant_and.push({ $eq: ['$is_hot', filter.value] });
                } else if (db_key === 'is_no_buy' && filter.value === true) {
                    $ref_bike_variant_and.push({ $eq: ['$is_no_buy', filter.value] });
                } else if (db_key === 'is_duplicate' && filter.value === true) {
                    $ref_bike_variant_and.push({
                        $or: [
                            { $exists: ['$duplicate_min', true] },
                            { $exists: ['$duplicate_max', true] },
                        ],
                    });
                } else if (db_key === 'model_OR_brand' && filter.value && filter.value.length) {
                    state.where_condition.model_OR_brand = filter.value;
                }
            }
        }
        state.where_condition.ref_bike_model.$and = $ref_bike_model_and;

        if ($ref_bike_variant_and.length) {
            state.where_condition.ref_bike_variant.$and = $ref_bike_variant_and;
        } else {
            state.where_condition.ref_bike_variant = undefined;
        }

        state.filters = { ...state.filters };
        // setVal(state.where_condition, action.params.db_key, action.params.value);
        return { ...state };


    case 'SET_BIKE_MANAGEMENT_KEY':
        setVal(state, action.params.path, action.params.value);
        return { ...state };

    case SEARCH_BIKE_MODELS_REQUEST:
        return {
            ...state,
            loading: true,
            models_data: null,
        };

    case SEARCH_BIKE_MODELS_SUCCESS:
        return {
            ...state,
            loading: false,
            models_data: action.payload,
        };

    case SEARCH_BIKE_MODELS_FAILURE:
        return {
            ...state,
            loading: false,
            models_data: null,
            error: action.error,
        };

    case SEARCH_BIKE_BRAND_REQUEST:
        return {
            ...state,
            loading: true,
            brands_data: null,
        };

    case SEARCH_BIKE_BRAND_SUCCESS:
        return {
            ...state,
            loading: false,
            brands_data: action.payload,
        };

    case SEARCH_BIKE_BRAND_FAILURE:
        return {
            ...state,
            loading: false,
            brands_data: null,
            error: action.error,
        };

    case SEARCH_BIKES_REQUEST:
        return {
            ...state,
            loading: true,
            bikes_found: undefined,
            searchedData: undefined,
            amount: 0,
        };

    case SEARCH_BIKES_SUCCESS:
        return {
            ...state,
            loading: false,
            bikes_found: action.payload,
            searchedData: action.payload,
        };

    case SEARCH_BIKES_FAILURE:
        return {
            ...state,
            loading: false,
            bikes_found: undefined,
            searchedData: undefined,
            error: action.error,
        };

    case SEARCH_BIKES_COUNT_REQUEST:
        return {
            ...state,
            loading: true,
            amount: 0,
        };

    case SEARCH_BIKES_COUNT_SUCCESS:
        return {
            ...state,
            loading: false,
            amount: action.payload,

        };

    case SEARCH_BIKES_COUNT_FAILURE:
        return {
            ...state,
            loading: false,
            amount: 0,
            error: action.error,
        };


    case SEARCH_BIKE_MODEL_REQUEST:
        return {
            ...state,
            loading: true,
            where: {
                ...state.where,
                ref_bike_model: action.value,
            },
        };
    case SEARCH_BY_BRAND_REQUEST:
        return {
            ...state,
            loading: true,
            where: {
                ...state.where,
                ref_bike_brand: action.searchText,
            },
        };
    case SEARCH_BY_BRAND_REQUEST_SUCCESS:
        return {
            ...state,
            loading: false,
            searchedData: payload,
            filteredBrands: payload,
        };
    case SEARCH_BIKE_MODEL_REQUEST_SUCCESS:
        return {
            ...state,
            loading: false,
            filteredModels: payload,
            searchedData: payload,
        };
    case SEARCH_BIKE_MODEL_REQUEST_FAILURE:
    case SEARCH_BY_BRAND_REQUEST_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.error,
        };

    case 'SHOW_TABLE':
        return {
            ...state,
            isShow: action.payload,
        };
    case FILTER_SEARCH_REQUEST:
    case SEARCH_HC_REQUEST:
        return {
            ...state,
            loading: true,
            where: { ...state.where, ...action.where },
        };
    case FILTER_SEARCH_REQUEST_SUCCESS:
    case SEARCH_HC_SUCCESS:
        return {
            ...state,
            loading: false,
            searchedData: action.payload,
        };
    case 'SWITCH_SEARCH':
        return {
            ...state,
            advancedSearch: action.payload,
            where: {},
            amount: 0,
        };
    case SEARCH_BIKE_REQUEST:
        return {
            ...state,
            loading: true,
            where: {
                ...state.where,
                ref_bike_brand: action.payload,
            },
        };
    case SEARCH_BIKE_REQUEST_SUCCESS:
        return {
            ...state,
            loading: false,
            searchedData: action.payload,
            isShow: true,
            where: {
                ...state.where,
                ref_bike_brand: action.payload.length ? action.payload[0].ref_bike_brand._id : null,
            },
        };
    case SEARCH_BIKE_REQUEST_FAILURE:
    case FILTER_SEARCH_REQUEST_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.error,
        };
    case GET_BIKE_MODELS_REQUEST:
        // if(!action.pagination) {
        //   action.pagination = state.pagination;
        // }
        // if(!action.where) {
        //   action.where = state.where;
        // }
        return {
            ...state,
            loading: true,
            // where: {
            //   ...state.where,
            // ref_bike_brand: action.payload.length ? action.payload[0].ref_bike_brand._id : null,
            // name: action.payload,
            // alternative_name: action.payload
            // }
            // pagination: {
            //   ...state.pagination, ...action.pagination
            // },
            // where: {
            //   ...state.where, ...action.where
            // }
        };

    case CHANGE_BIKE_MODEL_LIST_REQUEST:
        return {
            ...state,
            loading: true,
            model_id: action.model_id,
        };

    case GET_BIKE_MODELS_REQUEST_SUCCESS:
        return {
            ...state,
            loading: false,
            searchedData: payload.data,
            pagination: payload.pagination,
        };

    case COUNT_BIKE_MODELS_REQUEST_SUCCESS:
        return {
            ...state,
            amount: payload,
        };

    case CHANGE_BIKE_MODEL_LIST_REQUEST_SUCCESS:
        return {
            ...state,
            loading: false,
            searchedData: state.searchedData.map(m => (m._id === state.model_id
                ? { ...m, [key]: action.payload }
                : m)),
        };

    case 'RESET_ALL_FILTERS':
        return {
            ...state,
            loading: false,
            pagination: {
                page: 0,
                pageSize: 10,
            },
            where: {},
            searchedData: null,
            amount: 0,
        };

    case GET_BIKE_MODELS_REQUEST_FAILURE:
    case COUNT_BIKE_MODELS_REQUEST_FAILURE:
    case SEARCH_HC_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.error,
        };


    case 'RESET_FILTERS_BRAND':
        return {
            ...state,
            filteredBrands: state.filteredBrands,
        };
    case `${prefix}_BIKE_${item}_REQUEST`:
        return {
            ...state, model_id: action.model_id, condition,
        };
    case `${prefix}_BIKE_MODEL_VARIANTS_REQUEST`:
        return {
            ...state, loading: true, variant_id,
        };

    case CREATE_BIKE_MODEL_REQUEST_SUCCESS:
        return {
            ...state,
            loading: false,
            model: { ...state.model, model: payload },
        };

    case SEARCH_BY_REG_REQUEST_SUCCESS:
        return {
            ...state,
            filteredRegs: payload,
        };

    case GET_BIKE_MODEL_REQUEST_SUCCESS:
        return {
            ...state,
            loading: false,
            model: action.payload,
        };
    case CHANGE_BIKE_MODEL_REQUEST_SUCCESS:
        return {
            ...state,
            loading: false,
            model: { ...state.model, [key]: action.payload },
        };

    case `${prefix}_BIKE_MODEL_VARIANTS_REQUEST_SUCCESS`:
        return {
            ...state,
            variants: prefix === 'GET'
                ? action.variants
                : state.variants.map(v => (v._id === state.variant_id
                    ? Object.assign(
                        {},
                        v,
                        (key === 'is_hot' && variant === true)
                            ? { [key]: variant, is_no_buy: false }
                            : (key === 'is_no_buy' && variant === true)
                                ? { [key]: variant, is_hot: false }
                                : { [key]: variant },
                    ) : v)),
            loading: false,
        };

    case `${prefix}_BIKE_MODEL_VARIANTS_REQUEST_FAILURE`:
        return {
            ...state, loading: false, error,
        };

    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/BikeManagement/redux/reducers/bike_models.reducers.js